import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Environment, setAuthGateUrl, setClientId, setCookieDomain, setEnv, setResetPasswordRedirect } from '../utils/config';
import { getCookie } from '../utils/cookieManager';
import { refreshToken } from './refreshToken';
import { checkRefresh, setTokens } from './setTokens';
import { initBroadCastListener } from '../utils/broadcastListeners';
import { sendNewRelicEvent } from '../utils/newRelicEvents';

//@ts-ignore
import { version } from '../../package.json';
export { init };
var defaultParams = {
  env: Environment.prod,
  clientId: 'CHGG',
  refreshOnStart: true
};
function init(_x) {
  return _init.apply(this, arguments);
}
function _init() {
  _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _defaultParams$params, env, domainUrl, cookieDomain, clientId, refreshOnStart, resetPasswordSuccessRedirect, authGateUrl, cDomain, idToken, accessToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sendNewRelicEvent({
            EventName: 'init',
            version: version
          });
          if (typeof window !== 'undefined') {
            window.addEventListener('online', function () {
              return checkRefresh();
            });
          }
          _defaultParams$params = _objectSpread(_objectSpread({}, defaultParams), params), env = _defaultParams$params.env, domainUrl = _defaultParams$params.domainUrl, cookieDomain = _defaultParams$params.cookieDomain, clientId = _defaultParams$params.clientId, refreshOnStart = _defaultParams$params.refreshOnStart, resetPasswordSuccessRedirect = _defaultParams$params.resetPasswordSuccessRedirect, authGateUrl = _defaultParams$params.authGateUrl;
          setEnv(env);
          if (resetPasswordSuccessRedirect) {
            setResetPasswordRedirect(resetPasswordSuccessRedirect);
          }
          cDomain = cookieDomain || domainUrl;
          /* istanbul ignore else */
          if (env == Environment.test && domainUrl) {
            console.warn('`domainUrl` parameter is deprecated - please use `cookieDomain` instead');
          }
          if (cDomain) {
            setCookieDomain(cDomain);
          }
          if (authGateUrl) {
            setAuthGateUrl(authGateUrl);
          }
          setClientId(clientId);
          idToken = getCookie('id_token');
          accessToken = getCookie('access_token');
          initBroadCastListener();
          if (!(idToken && accessToken)) {
            _context.next = 17;
            break;
          }
          _context.next = 16;
          return setTokens({
            idToken: idToken,
            accessToken: accessToken,
            callInitSession: false
          });
        case 16:
          return _context.abrupt("return");
        case 17:
          if (!(idToken && refreshOnStart)) {
            _context.next = 20;
            break;
          }
          _context.next = 20;
          return refreshToken();
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _init.apply(this, arguments);
}